import i18n from "@/i18n";
import { CardsStates } from "../data/enums/cardsStates";

/**Состояние карты */
export default function cardState(cardState: CardsStates): string {
  let state: string = "";
  switch (cardState) {
    case CardsStates.Issued:
      state = i18n.t("main.cards.states.Issued").toString();
      break;
    case CardsStates.Active:
      state = i18n.t("main.cards.states.Active").toString();
      break;
    case CardsStates.Blocked:
      state = i18n.t("main.cards.states.Blocked").toString();
      break;
    case CardsStates.Unblocking:
      state = i18n.t("main.cards.states.Unblocking").toString();
      break;
    case CardsStates.ReIssued:
      state = i18n.t("main.cards.states.ReIssued").toString();
      break;
    case CardsStates.Deleting:
      state = i18n.t("main.cards.states.Deleting").toString();
      break;
    case CardsStates.Deleted:
      state = i18n.t("main.cards.states.Deleted").toString();
      break;
    case CardsStates.Blocking:
      state = i18n.t("main.cards.states.Blocking").toString();
      break;
    case CardsStates.SendingFromPC:
      state = i18n.t("main.cards.states.SendingFromPC").toString();
      break;
    case CardsStates.Closing:
      state = i18n.t("main.cards.states.Closing").toString();
      break;
    case CardsStates.Closed:
      state = i18n.t("main.cards.states.Closed").toString();
      break;
    case CardsStates.Expired:
      state = i18n.t("main.cards.states.Expired").toString();
      break;
    case CardsStates.ManualClosed:
      state = i18n.t("main.cards.states.ManualClosed").toString();
      break;
    case CardsStates.RECEIVEDFROMPC:
      state = i18n.t("main.cards.states.RECEIVEDFROMPC").toString();
      break;
    case CardsStates.SendedToAgent:
      state = i18n.t("main.cards.states.SendedToAgent").toString();
      break;
    case CardsStates.SendedToAgentByPost:
      state = i18n.t("main.cards.states.SendedToAgentByPost").toString();
      break;
    case CardsStates.ReceivedByAgent:
      state = i18n.t("main.cards.states.ReceivedByAgent").toString();
      break;
    case CardsStates.SendedToClient:
      state = i18n.t("main.cards.states.SendedToClient").toString();
      break;
    case CardsStates.SendedToClientByPost:
      state = i18n.t("main.cards.states.SendedToClientByPost").toString();
      break;
    case CardsStates.CoverDefective:
      state = i18n.t("main.cards.states.CoverDefective").toString();
      break;
    case CardsStates.CoverMissed:
      state = i18n.t("main.cards.states.CoverMissed").toString();
      break;
    default:
      state = "-";
      break;
  }

  return state;
}
